<template>
  <nav-link
    v-if="accessAllowed"
    role="listitem"
    :to="link"
    class="crumb"
    exact
  >
    <slot>
      {{ $t(label ?? '') }}
    </slot>
  </nav-link>
</template>

<script lang="ts" setup>
import NavLink from '@components/structure/navigation/NavLink.vue';
import type { RouteLocationRaw } from 'vue-router';
import {computed, toRef} from "vue";
import {canAccess} from "@/utils/user";
import {useLink} from "vue-router";
import {useLocation} from "@hooks/location";
import {useStore} from "@/store";

interface Props {
  link: RouteLocationRaw;
  label?: string;
}

const props = defineProps<Props>();

const store = useStore();
const user = computed(() => store.state.auth.user);

const toLocation = useLocation(toRef(props, 'link'));
const linkref = useLink({ to: toLocation });

const accessAllowed = computed(() => {
  const allowedRoles = linkref.route.value.meta.roles as string[];
  if (!allowedRoles) return true;
  return canAccess(user.value, allowedRoles);
});
</script>

<style lang="scss" scoped>
a {
  @apply text-tab text-tab-item;

  &.exact-active {
    @apply text-black;

    @include absolutePseudo("after") {
      left: 0;
      top: calc(100% + #{px(10)});
      height: 3px;
      width: 70%;
      background: var(--color-primary);
    }
  }
}
</style>
